import nextSkillsCover from '../assets/event-next-skills.jpg';
import meetupKiImage from '../assets/event-ki-meetup.jpg';
import speakerThomas from '../assets/speaker-thomas.jpg';
import speakerAntonia from '../assets/speaker-antonia.png';
import speakerGiesbrecht from '../assets/speaker-giesbrecht.png';
import protectDataImage3 from '../assets/protect-data-3.jpeg';
import localAiImage from '../assets/local-ai.jpeg';
import knowHowImage from '../assets/ki-know-how.jpg';

export type EventAgendaPhase = {
  label: string;
  minutes: number;
};

export type EventAgendaItem = {
  time: string;
  title: string;
  text?: string;
  points?: string[];
  phases?: EventAgendaPhase[];
  topics?: string[];
};

export type EventLocation = {
  name: string;
  lines: string[];
  phone?: string;
  email?: string;
};

export type EventSeries = {
  title: string;
  paragraphs: string[];
  pillars: { name: string; text: string }[];
};

export type EventSpeaker = {
  name: string;
  image: string;
  alt: string;
  text: string[];
};

export type EventShowroomTopic = {
  image: string;
  title: string;
  tags: string[];
  sentences: string[];
};

export type EventShowroom = {
  title: string;
  intro: string;
  topics: EventShowroomTopic[];
};

export type EventItem = {
  id: string;
  title: string;
  date?: string;
  dateISO?: string;
  meta: string;
  summary: string;
  image: string;
  alt: string;
  description: string[];
  agenda?: EventAgendaItem[];
  agendaNote?: string;
  series?: EventSeries;
  location?: EventLocation;
  organizer?: string;
  organizerNote?: string;
  contact?: string;
  questionIntro?: string;
  speakers?: EventSpeaker[];
  showroom?: EventShowroom;
};

export const events: EventItem[] = [
  {
    id: 'next-skills-2026-11-26',
    title: 'Next Skills – Betriebliche Weiterbildung vorausschauend gestalten',
    date: '26.11.2026',
    dateISO: '2026-11-26',
    meta: '26.11.2026, 17:00–19:30 Uhr · IMA Gütersloh, Langer Weg 7b, 33332 Gütersloh',
    summary:
      'Technologische Entwicklungen verändern Tätigkeiten, Rollen und Kompetenzanforderungen in Unternehmen. Die Veranstaltung fragt, welche Kompetenzen Beschäftigte brauchen, um die Arbeitswelt im Kontext von Industrie 5.0 mitzugestalten, und wie betriebliche Weiterbildung zukünftige Bedarfe frühzeitig erkennen kann. Unternehmen und Bildungsakteure tauschen sich dazu aus.',
    image: nextSkillsCover,
    alt: 'Next Skills – Betriebliche Weiterbildung vorausschauend gestalten, 26. November 2026, IMA Gütersloh',
    description: [
      'Technologische Entwicklungen verändern Tätigkeiten, Rollen und Kompetenzanforderungen in Unternehmen. Damit stellt sich für die betriebliche Weiterbildung die Frage, wie sich neben aktuellen Qualifizierungsbedarfen auch zukünftige Kompetenzanforderungen frühzeitig erkennen und adressieren lassen.',
      'Welche Kompetenzen brauchen Beschäftigte, um die Arbeitswelt im Kontext von Industrie 5.0 aktiv mitzugestalten? Und wie kann betriebliche Weiterbildung darauf vorausschauend reagieren? Diesen Fragen gehen Unternehmen und Bildungsakteure gemeinsam nach. Im Mittelpunkt stehen der Austausch über zukünftige Kompetenzbedarfe, Möglichkeiten ihrer frühzeitigen Erkennung und die Gestaltung einer zukunftsorientierten betrieblichen Weiterbildung.',
    ],
    agenda: [
      { time: '16:30 Uhr', title: 'Einlass' },
      {
        time: '17:00–17:10 Uhr',
        title: 'Begrüßung und Einführung',
        points: ['Begrüßung', 'Vorstellung des Projekts Smart Transform 5.0'],
      },
      {
        time: '17:10–17:40 Uhr',
        title: 'Impulsvortrag: Arbeitswelt im Wandel',
        points: [
          'Prof. Dr. Thomas Süße (Hochschule Bielefeld)',
          'Antonia Schulte (MINTkitchen KG)',
          'Erika Giesbrecht (Arbeitneudenken.ai)',
        ],
      },
      { time: '17:40–17:50 Uhr', title: 'Pause' },
      {
        time: '17:50–18:35 Uhr',
        title: 'Moderierte Gruppendiskussionen',
        points: [
          'Arbeit im Wandel – Was verändert sich?',
          'Kompetenzen von morgen – Was müssen Beschäftigte können?',
          'Kompetenz-Vorausschau – Wie erkennen wir zukünftige Bedarfe?',
          'Weiterbildung mit Weitblick – Wie entwickeln wir diese Kompetenzen?',
        ],
      },
      {
        time: '18:35–18:50 Uhr',
        title: 'Gemeinsame Auswertung und Diskussion',
        points: ['Kurzvorstellung der zentralen Ergebnisse aus den Gruppendiskussionen'],
      },
      {
        time: '18:50–19:00 Uhr',
        title: 'Abschluss und Ausblick',
        points: ['Zusammenfassung der wichtigsten Erkenntnisse'],
      },
      { time: 'Ab 19:00 Uhr', title: 'Networking' },
    ],
    location: {
      name: 'IMA Gütersloh',
      lines: ['Langer Weg 7b', '33332 Gütersloh'],
      phone: '+49 1517 0650315',
      email: 'hallo@ima-gt.de',
    },
    organizer: 'MINTkitchen KG',
    contact: 'Antonia Schulte',
    speakers: [
      {
        name: 'Prof. Dr. Thomas Süße',
        image: speakerThomas,
        alt: 'Prof. Dr. Thomas Süße',
        text: [
          'Prof. Dr. Thomas Süße ist seit 2019 Professor für Personal und Organisation an der Hochschule Bielefeld und forscht in den Bereichen Kompetenzen und Kompetenzanforderungen im digitalen Wandel, Mensch-KI Kooperation & Kollaboration und modernen KI-Tools (z.B. ChatGPT) in der Aus- und Weiterbildung. Dabei beschäftigt er sich vor allem mit der Frage, welche Dynamiken neue Technologien in Bildung, Arbeit und Gesellschaft auslösen.',
        ],
      },
      {
        name: 'Antonia Schulte',
        image: speakerAntonia,
        alt: 'Antonia Schulte',
        text: [
          'Antonia Schulte ist Geschäftsführerin der MINTkitchen. Als ausgebildete Gymnasiallehrerin entwickelt sie moderne Bildungsansätze, die Menschen und Organisationen befähigen, technologische und gesellschaftliche Veränderungen aktiv mitzugestalten. Ihr Schwerpunkt liegt auf Zukunftskompetenzen, KI-Souveränität und der Weiterentwicklung von Bildung und Lernen im Kontext der digitalen Transformation. Dabei betrachtet sie das Zusammenspiel von menschlichen Kompetenzen, technologischen Möglichkeiten und organisationalen Rahmenbedingungen.',
        ],
      },
      {
        name: 'Erika Giesbrecht',
        image: speakerGiesbrecht,
        alt: 'Erika Giesbrecht',
        text: [
          'Erika Giesbrecht ist Gründerin von Arbeitneudenken.ai und Expertin für Personal- und Organisationsentwicklung in der KI-Transformation. In einem Produktionsunternehmen hat sie die Weiterbildung aufgebaut und dort sowohl ein Lernmanagementsystem als auch erste KI-Qualifizierungen eingeführt. Ihr Fokus liegt auf dem Menschen: bei Rollen, Kompetenzen und Lernstrukturen, die KI im Arbeitsalltag wirksam machen.',
        ],
      },
    ],
  },
  {
    id: 'meetup-souveraene-ki-2027-01-20',
    title: 'Meetup Souveräne KI',
    date: '20.01.2027',
    dateISO: '2027-01-20',
    meta: '20.01.2027, Uhrzeit wird noch bekannt gegeben · IMA Gütersloh, Langer Weg 7b, 33332 Gütersloh',
    summary:
      'Souveränität in der KI-Welt ist die Fähigkeit, selbstbestimmt zu handeln, statt sich dauerhaft auf fremde Systeme zu verlassen. In diesem Meetup befassen wir uns praxisnah mit dem, was unter der Motorhaube passiert. Interessierte aller Fachbereiche sind herzlich willkommen.',
    image: meetupKiImage,
    alt: 'Meetup Souveräne KI, 20. Januar 2027, IMA Innovationsmanufaktur Gütersloh',
    description: [],
    agenda: [
      {
        time: '30 Minuten',
        title: 'Ankommen und Themenfestlegung',
        text:
          'Die konkreten Themen des Meetups werden nach einer kurzen Vorstellungsrunde mit den Teilnehmenden abgestimmt. Eigene Beiträge können von Teilnehmenden entweder im Vorfeld eingereicht oder spontan zum Meetup mitgebracht werden.',
      },
      {
        time: '3 x 40 Minuten',
        title: 'Drei thematische Slots',
        topics: ['Thema 1', 'Thema 2', 'Thema 3'],
        phases: [
          { label: 'Einführung', minutes: 10 },
          { label: 'Hands-on', minutes: 15 },
          { label: 'Q&A', minutes: 15 },
        ],
      },
      {
        time: '30 Minuten',
        title: 'Feedbackrunde',
        text: 'Rückmeldung zum Abend und Vorschläge für das nächste Meetup.',
      },
    ],
    series: {
      title: 'Das Meetup zu KI-Souveränität',
      paragraphs: [
        'KI-Souveränität ist die Fähigkeit, KI selbstbestimmt, sicher, unabhängig und nachhaltig zu entwickeln, einzusetzen und zu kontrollieren. Das Meetup KI Souveränität richtet sich an Menschen aus Betrieben aller Art und Größe, die KI nicht nur in Form fertiger Tools von Dritten einsetzen, sondern verstehen und steuern wollen. Dieses etwa alle 2 Monate stattfindende Meetup adressiert sechs thematische Säulen souveräner KI-Anwendung und ist von praktischen Anwendungen, Prototypen und Demonstrationen geprägt.',
      ],
      pillars: [
        {
          name: 'Hardware & Infrastruktur',
          text: 'Lokale Inferenz, Edge AI und der Software-Stack, auf dem die Systeme laufen.',
        },
        {
          name: 'Schutz sensibler Daten',
          text: 'Personenbezogene Daten, Geschäftsgeheimnisse, Forschungsprojekte und geistiges Eigentum im laufenden Einsatz schützen.',
        },
        {
          name: 'Mensch, Kompetenz, Bildung',
          text: 'Beschäftigte verstehen, wie ein KI-System im Kern funktioniert und was der Einsatz genau dieses Systems im eigenen Betrieb bedeutet.',
        },
        {
          name: 'Compliance',
          text: 'Welche Entscheidung bei der Einführung welche Folge für bestehende Compliance-Pflichten hat.',
        },
        {
          name: 'Implementierung',
          text: 'KI-Systeme selbst einführen oder die Führung behalten, wenn ein Dienstleister mitarbeitet.',
        },
        {
          name: 'Unabhängigkeit',
          text: 'Anbieter- und Plattformbindung vermeiden, damit Daten, Modelle und Werkzeuge austauschbar bleiben.',
        },
      ],
    },
    location: {
      name: 'IMA Gütersloh',
      lines: ['Langer Weg 7b', '33332 Gütersloh'],
    },
    organizer: 'MINTkitchen KG',
    organizerNote: 'im Rahmen des Förderprojekts Smart Transform 5.0',
    contact: 'Wilhelm Klat',
    questionIntro:
      'Haben Sie Fragen zu diesem Meetup oder möchten Sie ein Projekt als Beitrag vorstellen? Schreiben Sie uns gerne an.',
    showroom: {
      title: 'Beliebte Themen im Meetup',
      intro:
        'Grundsätzlich ist das Meetup offen gegenüber allen Themen, die unter die Idee der KI\u2011Souveränität fallen.\nFolgende Themen werden regelmäßig behandelt.',
      topics: [
        {
          image: localAiImage,
          title: 'KI lokal betreiben',
          tags: ['KI', 'Resilienz'],
          sentences: [
            'KI Souveränität bedeutet, KI auch auf lokalen Geräten für die betriebliche Nutzung zu betreiben.',
            'Lokale KI bietet zahlreiche Vorteile für Betriebe, wie z.B. eine größere Unabhängigkeit von ausländischen Plattformen, mehr Transparenz über interne Vorgänge im KI-System und die Herrschaft über die eigenen Daten.',
            'In diesem Meetup arbeiten wir insbesondere mit standardisierten lokalen KI-Systemen auf Basis von Nvidia Jetson/DGX Spark sowie Mac Studio für den lokalen Betrieb von Sprachmodellen, RAG und agentischen Systemen.',
          ],
        },
        {
          image: protectDataImage3,
          title: 'Sensible Geschäftsdaten schützen',
          tags: ['KI', 'Resilienz'],
          sentences: [
            'Im betrieblichen Kontext muss sichergestellt werden, dass durch die Nutzung von KI-Tools keine sensiblen Geschäftsgeheimnisse in unsichere Systeme Dritter gelangen.',
            'Während die DSGVO lediglich den Schutz personenbezogener Daten adressiert, steht hier jedoch der Schutz von Geschäftsgeheimnissen im Vordergrund, wie z.B. F&E Projekte oder Vereinbarungen mit Kunden und Lieferanten.',
            'Die Identifikation von Geschäftsgeheimnissen im Rahmen von KI-Nutzung ist jedoch deutlich komplexer als personenbezogene Daten.',
            'In diesem Meetup befassen wir uns mit Methoden und Werkzeugen, wie sich sensible Geschäftsdaten lokal detektieren und ihr unerlaubter Abfluss an Dritte verhindert werden kann.',
          ],
        },
        {
          image: knowHowImage,
          title: 'Aufbau von KI-Know How',
          tags: ['KI', 'Mensch'],
          sentences: [
            'KI-Souveränität setzt voraus, dass Betriebe die Funktionsweise von KI-Systemen verstehen und wichtige Entscheidungen bei der Implementierung und Nutzung qualifiziert treffen.',
            'Dafür braucht es mehr als das reine Verständnis über die Bedienung.',
            'Betriebe müssen u.a. verstehen, wie und wo Daten gespeichert und verarbeitet werden, warum KI-Systeme Fehler machen können oder welche Methoden für die Dokumentenverarbeitung für den eigenen Betrieb am sinnvollsten sind.',
            'In diesem Meetup besprechen wir, welche Kompetenzen dafür erforderlich sind und wie Qualifizierungsmaßnahmen gestaltet werden müssen, um dieses KI-Know How aufzubauen.',
          ],
        },
      ],
    },
  },
];

export function getEvent(id: string | undefined): EventItem | undefined {
  return events.find((event) => event.id === id);
}
